<template>
	<div>
		<myheader headTitle="区块链存证记录"></myheader>
		<div class="all_main ">
			<!-- <div class="all_content_padding" v-for="(item,index) in contractEvidenceNodes" :key="index"> -->
			<!-- {{(contractEvidenceNodes.length>1?'第'+(index+1)+'次':'') +'签约流程'}} -->
			<div class="text12 textcoloblack font_weight_700 margin_top_5" style="margin-left: .5rem;">
				签约流程
			</div>
			<div class="all_details_content_card margin_top_2" v-if="contractEvidence">
				<van-steps direction="vertical" :active="-1" inactive-color="#a1a1a1" style="padding-left: 20px;">
					<van-step>
						<div class="text12 textcolor333 font_weight_bold">{{contractEvidence.beginTitle}}</div>
						<div style="padding: .5rem;padding-right: 0;">
							<div>
								<div class="text12 textcolor333 font_weight_bold display_inline_block"
									style="width: 68%;">{{contractEvidence.beginInfo.title}}</div>
							</div>
							<div class="margin_top_3 display_flex">
								<div class="text12 textcolor999" style="flex:1;">
									{{Tool.dateFormate(contractEvidence.beginInfo.bizTime)}}
								</div>
								<img style="width: .8rem;height: .8rem;margin: .1rem .2rem;"
									src="@/assets/images/selected.svg" />
								<span class="text12 textcolormain all_line_height10"
									@click="getContractEvidenceDetails(contractEvidence.beginInfo.evidenceCode,contractEvidence.beginInfo.bizState)">{{contractEvidence.beginInfo.bizState}}</span>
							</div>
						</div>
					</van-step>
					<van-step>
						<div class="text12 textcolor333 font_weight_bold">{{contractEvidence.authTitle}}</div>
						<div v-for="(auth,ak) in contractEvidence.authList" :key="ak"
							style="padding: .5rem;padding-right: 0;">
							<div>
								<div class="text12 textcolor333 font_weight_bold display_inline_block"
									style="width: 68%;">{{auth.title}}</div>
							</div>
							<div class="margin_top_3 display_flex">
								<div class="text12 textcolor999 " style="flex: 1;">
									{{Tool.dateFormate(auth.bizTime)}}
								</div>
								<img style="width: .8rem;height: .8rem;margin: .1rem .2rem;"
									src="@/assets/images/selected.svg" />
								<span class="text12 textcolormain all_line_height10"
									@click="getContractEvidenceDetails(auth.evidenceCode,auth.bizState)">{{auth.bizState}}</span>
							</div>
						</div>
					</van-step>
					<van-step v-if="contractEvidence.actTitle||contractEvidence.actList.lenght>0">
						<div class="text12 textcolor333 font_weight_bold">{{contractEvidence.actTitle}}</div>
						<div v-for="(act,sk) in contractEvidence.actList" :key="sk"
							style="padding: .5rem;padding-right: 0;">
							<div>
								<div class="text12 textcolor333 font_weight_bold display_inline_block"
									style="width: 20%;">{{act.title}}</div>
								<div class="text12 textcolor333 font_weight_bold display_inline_block"
									style="width: 80%;">
									{{act.corpName}}
								</div>
							</div>
							<div class="margin_top_3 display_flex">
								<div class="text12 textcolor999 " style="flex: 1;">
									{{Tool.dateFormate(act.bizTime)}}
								</div>
								<img style="width: .8rem;height: .8rem; margin: .1rem .2rem;"
									src="@/assets/images/selected.svg" />
								<span class="text12 textcolormain all_line_height10"
									@click="getContractEvidenceDetails(act.evidenceCode,act.bizState)">{{act.bizState}}</span>
							</div>
						</div>
					</van-step>
					<van-step v-if="contractEvidence.endTitle||contractEvidence.endList.lenght>0">
						<div class="text12 textcolor333 font_weight_bold">{{contractEvidence.endTitle}}
						</div>
						<div v-for="(end,ck) in contractEvidence.endList" :key="ck"
							style="padding: .5rem;padding-right: 0;">
							<div>
								<div class="text12 textcolor333 font_weight_bold display_inline_block"
									style="width: 68%;">{{end.title}}</div>
							</div>
							<div class="margin_top_3 display_flex">
								<div class="text12 textcolor999" style="flex: 1;">
									{{Tool.dateFormate(end.bizTime)}}
								</div>
								<img style="width: .8rem;height: .8rem;margin: .1rem .2rem;"
									src="@/assets/images/selected.svg" />
								<span class="text12 textcolormain all_line_height10"
									@click="getContractEvidenceDetails(end.evidenceCode,end.bizState)">{{end.bizState}}</span>
							</div>
						</div>
					</van-step>
				</van-steps>
			</div>
			<!-- </div> -->
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Step,
		Steps,
	} from 'vant';
	export default {
		components: {
			[Step.name]: Step,
			[Steps.name]: Steps,
		},
		data() {
			return {
				//合同id
				contractId: '',
				// 企业id
				corpId: '',
				//上链信息
				contractEvidence: null,
			}
		},
		methods: {
			//获取合同区块链列表信息
			getContractEvidenceList() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/contract/api/getContractDetailGraph?contractId=" + this.contractId)
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.contractEvidence = res.data
						}
					});
			},
			//获取合同区块链详情
			getContractEvidenceDetails(evidenceCode, bizState) {
				this.$router.push({
					path: "/verifdetails",
					query: {
						evidenceCode: evidenceCode,
						bizState:bizState,
					},
				});
				if (!evidenceCode) {
					return
				}
				//屏蔽，pc端没有此功能
				return
				this.$store.dispatch(this.$LoadShow, true)
				this.$get("/evidence/api/getEvidence?code=" + evidenceCode)
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							if (res.data.rawContractEvidenceEntry) {
								res.data.evidenceData = res.data.rawContractEvidenceEntry
							}
							if (res.data.authResultContractEvidenceEntry) {
								res.data.evidenceData = res.data.authResultContractEvidenceEntry
							}
							if (res.data.mailContractEvidenceEntry) {
								res.data.evidenceData = res.data.mailContractEvidenceEntry
							}
							if (res.data.completeContractEvidenceEntry) {
								res.data.evidenceData = res.data.completeContractEvidenceEntry
							}
							if (res.data.cancelContractEvidenceEntry) {
								res.data.evidenceData = res.data.cancelContractEvidenceEntry
							}
							this.$store.commit("changeCertVerifInfo", res.data)
							this.$router.push({
								path: "/verifdetails",
								query: {
									type: '0',
								},
							});
						}
					});
			},
			//初始化
			init() {
				this.contractId = this.$route.query.contractId
				this.corpId = this.$route.query.corpId
				this.getContractEvidenceList()
			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>